import type { ISingleOrderStep } from 'widgets/AnketaWidget';

type InitialValidationStepsOptions = {
  isAuth?: boolean;
  initialOpenStepId?: string;
  isEnabled?: boolean;
  isFirstValidation?: boolean;
};

export const getValidationSteps = (allSteps: ISingleOrderStep[], options: InitialValidationStepsOptions) => {
  const { isAuth, initialOpenStepId, isEnabled = true, isFirstValidation } = options;
  const allStepIds = allSteps.map((step) => step.formId);

  if (!isEnabled) {
    return [];
  }

  if (isFirstValidation && initialOpenStepId) {
    return allStepIds.slice(
      0,
      allSteps.findIndex((step) => step.formId === initialOpenStepId),
    );
  }

  if (isAuth) {
    return allStepIds;
  }

  return [];
};
